module.exports = __webpack_public_path__ + "img/plusadd.9b5d9d73.svg";